module.exports = __webpack_public_path__ + "jc1.png?33787a3b15ffda4a22554b938bc2d87d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jc1.png
// module id = 639
// module chunks = 0